module.exports = __webpack_public_path__ + "static/filters_redesign_2-5f86619a19acc58172dc7d32ba49660c.png";